jQuery(function ($) {
    $( document ).ready(function() {
        $('.latest-success-stories__lower').align({
            selector: '.single-story__wrapper > *'
        });

        $('.news-stories').align({
            selector: '.single-story__wrapper > *'
        });

        $('.news-index-block__wrapper .view-more-button').on('click', function () {
            setTimeout(function () {
                $('.news-stories').align({
                    selector: '.single-story__wrapper > *'
                });
            }, 100);
        });
    });
});